import React from "react";
import { Link } from "react-router-dom";
import IMAGE_1 from "./images/imgi_13_welcome-2.jpg";
import IMAGE_2 from "./images/imgi_14_welcome-4.jpg";
import IMAGE_3 from "./images/imgi_17_welcome-3.jpg";
import IMAGE_4 from "./images/imgi_16_welcome_two.png";

const Aboutmain = () => {
  return (
    <section className="py-8 md:py-16 px-4 md:px-12 max-w-6xl mx-auto w-full font-inter overflow-hidden">
      {/* Forced row for mobile: items won't stack, they will just get smaller */}
      <div className="flex flex-row items-center lg:items-stretch gap-4 md:gap-12">
        
        {/* Left Section: Visuals */}
        <div className="w-[45%] md:w-[40%] relative min-h-[200px] md:min-h-[480px] shrink-0">
          {/* Main Image */}
          <div className="relative w-[92%] h-[92%] rounded-xl md:rounded-[1.5rem] overflow-hidden shadow-xl border border-gray-100">
            <img
              src={IMAGE_1}
              alt="Students"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Floating Image 2 */}
          <div className="absolute right-0 bottom-3 md:bottom-12 w-20 h-20 md:w-44 md:h-44 rounded-xl md:rounded-2xl overflow-hidden shadow-2xl border-2 md:border-[4px] border-white z-10">
            <img src={IMAGE_2} alt="Session" className=" w-full h-full object-cover md" />
          </div>

          {/* Ribbon Effect - Positioned at the very bottom of the image group */}
          <div className="absolute bottom-0 left-0 z-20 w-full transform translate-y-2">
            <div 
              className="flex items-center gap-1 md:gap-3 px-2 md:px-4 py-1.5 md:py-3 bg-gradient-to-r from-[#63B977] via-[#8DC63F] to-[#FFD242] text-[#002D3A] font-bold shadow-lg"
              style={{
                clipPath: "polygon(0% 0%, 92% 0%, 100% 50%, 92% 100%, 0% 100%)",
                width: "fit-content",
                paddingRight: "2.5rem"
              }}
            >
              
              <div className="shrink-0">
                <svg className="w-3 h-3 md:w-5 md:h-5 justify-center" fill="currentColor" viewBox="0 0 24 24">
                  <path d=" M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                </svg>
              </div>
              <span className="text-[6px] md:text-sm whitespace-nowrap uppercase tracking-tighter md:tracking-normal">
                 A decade of Legacy with proven expertise !
              </span>
            </div>
            
          </div>
        </div>

        {/* Right Section: Content */}
        <div className="w-[55%] md:w-[60%] flex flex-col justify-center text-left">
          <div className="mb-2 md:mb-4">
            <span className="inline-block text-green-600 font-bold tracking-widest uppercase text-[8px] md:text-[10px] mb-1 px-2 py-0.5 bg-green-50 rounded-md">
              About Our Academy
            </span>
            <h1 className="text-xs md:text-4xl font-black text-gray-900 leading-tight">
              ISLAMIC ONLINE MADRASAH
            </h1>
            <h2 className="text-[10px] md:text-xl font-bold text-gray-500 mb-2">
              Online Islamic School At Home
            </h2>
            <div className="w-8 md:w-16 h-0.5 md:h-1 bg-green-500 rounded-sm"></div>
          </div>

          <p className="text-gray-600 text-[9px] md:text-base mb-4 leading-tight line-clamp-2 md:line-clamp-none">
            We welcome you to Online Quran teaching services offering multiple Islamic and character-building courses.
          </p>

          {/* Features Column + Circle Image */}
          <div className="flex flex-row items-center gap-2 md:gap-6 mb-4">
            <div className="flex flex-col gap-2 w-full">
              <div className="flex items-center gap-2 p-1.5 md:p-3 rounded-lg bg-white border border-gray-100 shadow-sm">
                <div className="w-6 h-6 md:w-10 md:h-10 shrink-0 rounded-md bg-green-100 flex items-center justify-center text-green-600">
                  <svg className="w-3 h-3 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
                <h3 className="font-bold text-gray-900 text-[8px] md:text-sm">Flexible Learning</h3>
              </div>

              <div className="flex items-center gap-2 p-1.5 md:p-3 rounded-lg bg-white border border-gray-100 shadow-sm">
                <div className="w-6 h-6 md:w-10 md:h-10 shrink-0 rounded-md bg-green-100 flex items-center justify-center text-green-600">
                  <svg className="w-3 h-3 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.247 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                </div>
                <h3 className="font-bold text-gray-900 text-[8px] md:text-sm">Expert Guidance</h3>
              </div>
            </div>

            <div className="w-16 h-16 md:w-40 md:h-40 shrink-0">
              <div className="w-full h-full rounded-full border-2 md:border-4 border-green-50 overflow-hidden shadow-inner">
                 <img src={IMAGE_4} className="w-full h-full object-cover" alt="Focus" />
              </div>
            </div>
          </div>

          {/* Experience Card */}
          <div className="bg-green-50 rounded-xl md:rounded-2xl p-2 md:p-4 ">
            <div className="flex items-center gap-2 md:gap-4">
              <div className="w-12 h-12 md:w-28 md:h-28 shrink-0">
                <img src={IMAGE_3} alt="Experience" className="w-full h-full object-contain" />
              </div>
              <div className="text-left">
                <h3 className="text-[10px] md:text-lg font-bold text-gray-900 leading-tight">Operating since more than 15 years</h3>
                <p className="text-green-800 text-[8px] md:text-xs">Trusted by thousands of families worldwide.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutmain;